import { get, max, min, forEach, filter, merge, size } from "lodash";
import { getAttributeValue /*getLovValue*/ } from "../utils/profile";
import {
  BODY_TYPE,
  CELSIUS_THRESHOLD,
  FAHRENHEIT_THRESHOLD,
  ISO_TYPE,
  MANUAL_TYPE,
} from "../constants/common";

export const getTemperatureByOperation = (eventGroup, operation) => {
  let isoTemperatures = [];
  let bodyTemperatures = [];
  let manualTemperatures = [];

  forEach(get(eventGroup, ["events"]), (e) => {
    if (get(e, ["type", "id"]) === 82 && get(e, ["active"])) {
      let maxBodyTemp = getAttributeValue(
        e,
        getDisplayedTemperatureAttr(BODY_TYPE)
      );
      let maxIsoTemp = getAttributeValue(
        e,
        getDisplayedTemperatureAttr(ISO_TYPE)
      );
      let maxManualTemp = getAttributeValue(
        e,
        getDisplayedTemperatureAttr(MANUAL_TYPE)
      );
      if (maxBodyTemp) bodyTemperatures.push(maxBodyTemp);
      if (maxIsoTemp) isoTemperatures.push(maxIsoTemp);
      if (maxManualTemp) manualTemperatures.push(maxManualTemp);
    }
  });

  if (operation === "min") {
    return min(merge(isoTemperatures, bodyTemperatures, manualTemperatures));
  } else if (operation === "max") {
    if (size(isoTemperatures) > 0) {
      return max(isoTemperatures);
    }
    return max(merge(bodyTemperatures, manualTemperatures));
  }
  return null;
};

export const getThreshold = (eventGroup) => {
  let threshold;
  forEach(get(eventGroup, ["events"]), (e) => {
    threshold = getThresholdEvent(e);
  });
  return threshold;
};

export const getThresholdEvent = (e) => {
  let temperatureType;
  if (get(e, ["type", "id"]) === 82) {
    if (getAttributeValue(e, 88)) temperatureType = getAttributeValue(e, 88);
  }
  if (temperatureType === 19) {
    return FAHRENHEIT_THRESHOLD;
  } else {
    // default to Celsius
    return CELSIUS_THRESHOLD;
  }
};

// Currently display max iso/body temp
export const getDisplayedTemperatureAttr = (type) => {
  if (type === ISO_TYPE) {
    //return 166;
    return 168;
  } else if (type === BODY_TYPE) {
    //return 153;
    return 165;
  } else if (type === MANUAL_TYPE) {
    return 187;
  }
};

export const getMeasureType = (e) => {
  return getAttributeValue(e, 187) !== null
    ? MANUAL_TYPE
    : getAttributeValue(e, 153) === null &&
      getAttributeValue(e, 164) === null &&
      getAttributeValue(e, 165) === null
    ? ISO_TYPE
    : BODY_TYPE;
};

export const isOverThreshold = (value, threshold) => {
  if (parseFloat(parseFloat(value).toFixed(1)) >= threshold) {
    return true;
  }
  return false;
};

export const getMeasureUnit = (e, lov) => {
  const unit = get(
    filter(get(e, ["attributes"]), (attr) => attr.id === 88),
    [0, "value"]
  );
  if (unit === 19) {
    return "°F";
  }
  return "°C";
  // return (
  //   getLovValue(
  //     88,
  //     get(
  //       filter(get(e, ["attributes"]), (attr) => attr.id === 88),
  //       [0, "value"]
  //     ),
  //     lov,
  //     "en"
  //   ) || "°C"
  // );
};

export const displayedTemperature = (e, attrId, lov) => {
  if (isNaN(parseFloat(getAttributeValue(e, attrId)))) {
    return "-";
  }
  return `${parseFloat(getAttributeValue(e, attrId)).toFixed(
    1
  )}${getMeasureUnit(e, lov)}`;
};

export const getMaxThermalPicture = (measureEvent) => {
  let maxPicture = get(measureEvent, ["images", 0]);
  forEach(get(measureEvent, ["images"]), (img) => {
    let imgValue = get(img, ["thermal_pixel_coordinate", "value"]);
    if (imgValue > get(maxPicture, ["thermal_pixel_coordinate", "value"])) {
      maxPicture = img;
    }
  });
  return maxPicture;
};

export const getFinalTemperature = (temperatureEventGroup) => {
  let maxTemp = 0;
  let maxEvent;
  forEach(get(temperatureEventGroup, ["events"]), (e) => {
    if (get(e, ["active"])) {
      let temp =
        getAttributeValue(e, getDisplayedTemperatureAttr(ISO_TYPE)) ||
        getAttributeValue(e, getDisplayedTemperatureAttr(BODY_TYPE)) ||
        getAttributeValue(e, getDisplayedTemperatureAttr(MANUAL_TYPE));
      if (temp > maxTemp) {
        maxEvent = e;
        maxTemp = temp;
      }
    }
  });
  return [maxTemp, maxEvent];
};
